<template>
  <div class="mdc-form-field" :class="classes">
    <div class="mdc-radio">
      <input
        class="mdc-radio__native-control"
        type="radio"
        @change="updateInput"
        :checked="shouldBeChecked"
        :value="value"
        :id="id"
        :disabled="disabled"
        :name="name"
      />
      <div class="mdc-radio__background">
        <div class="mdc-radio__outer-circle"></div>
        <div class="mdc-radio__inner-circle"></div>
      </div>
      <div class="mdc-radio__ripple"></div>
    </div>
    <label :for="id" v-if="$slots['default']" class="mdc-radio-button__label">
      <!-- @slot Radiobutton label -->
      <slot />
    </label>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  model: {
    prop: "checkedValue",
    event: "change"
  },
  data() {
    return {
      id: `am-radio-${this._uid}`,
      input: undefined
    };
  },
  props: {
    /**
     * Input value
     */
    value: {
      type: String,
      required: true
    },
    /**
     * Full width
     */
    fullWidth: {
      type: Boolean,
      default: true
    },
    /**
     * Modal value
     */
    checkedValue: {
      type: String,
      required: true
    },
    /**
     * Group name
     */
    name: {
      type: String,
      default: "radio"
    },
    /**
     * Disabled state
     */
    disabled: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.input = this.$el.querySelector("input");
  },
  computed: {
    shouldBeChecked() {
      return this.checkedValue === this.value;
    },
    classes() {
      return {
        "mdc-radio--full-width": this.fullWidth
      };
    }
  },
  methods: {
    updateInput(e) {
      e.target.checked = this.shouldBeChecked;

      this.$emit("change", this.value);
    }
  }
};
</script>
